import { render, staticRenderFns } from "./MenuApp.vue?vue&type=template&id=74edfd72"
import script from "./MenuApp.vue?vue&type=script&lang=js"
export * from "./MenuApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports